import urlService from '../services/rbata.urlService';
import page from '../utils/rbata.page';
import removeCartItem from './rbata.remove-item';
import crossSellingComponent from '../components/rbata.crossSellingComponent';
import spinner from '../utils/rbata.spinner';
import cartTracking from '../tracking/rbata.tracking.cart';
import consumerEvents from '../tracking/rbata.consumer-events';
import logger from '../utils/rbata.logger';
import selectQuantity from './rbata.select-quantity';
import voucherHandling from './rbata.voucher';

const miniCart = {
    close:                 undefined,
    remove:                undefined,
    cart:                  undefined,
    body:                  undefined,
    timeout:               undefined,
    active:                false,
    showMiniCartAfterLoad: false,

    cacheSelectors() {
        miniCart.body = $('body');
        miniCart.remove = this.body.find('.js-miniCart__remove');
        miniCart.close = this.body.find('.js-miniCart__close');
        miniCart.cart = this.body.find('.miniCart__wrapper');
    },

    attachEvents() {
        miniCart.body.on('click', '.js-miniCart__close', miniCart.hideMiniCart);
        miniCart.body.on('click', '.js-miniCart__remove', miniCart.removeItem);
        miniCart.body.on('click', '.js-miniCart__dec', miniCart.changeAmount.bind(this, 'removeFromCart'));
        miniCart.body.on('click', '.js-miniCart__inc', miniCart.changeAmount.bind(this, 'addToCart'));
        miniCart.body.on('click', '.js-minicart-proceed-to-checkout', miniCart.proceedToCheckout);
        miniCart.body.on('mouseenter touchstart click', '.miniCart__wrapper', miniCart.cancelTimeout);
        miniCart.body.on('mouseleave', '.miniCart__wrapper', miniCart.closeOnTime);
    },

    load: (silent = false) => {
        $.get(`${urlService.getBaseUrl()}cart/fragment/`, (data) => {
            miniCart.cart.replaceWith(data);
            miniCart.cacheSelectors();
            if (!silent) {
                miniCart.cart.fadeIn();
            } else {
                miniCart.cart.show();
            }
            crossSellingComponent.miniCartInit(silent);
            voucherHandling.cacheSelectors();
        }).always(() => {
            miniCart.checkIfCartEmpty();
        });
    },

    attachMock: () => {
        if (!miniCart.body.find('.miniCart__wrapper').length) {
            miniCart.body.append(
                    `<div class="miniCart__wrapper" style="display: none;">
                        <svg class="loading-spinner__image" xmlns="http://www.w3.org/2000/svg"  version="1.0" width="60px" height="60px" viewBox="0 0 128 128" xml:space="preserve">
                            <g>
                                <path d="M64 128A64 64 0 0 1 18.34 19.16L21.16 22a60 60 0 1 0 52.8-17.17l.62-3.95A64 64 0 0 1 64 128z" fill="#000000"/>
                                <animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="2200ms" repeatCount="indefinite"></animateTransform>
                            </g>
                        </svg>
                    </div>`);
            miniCart.cacheSelectors();
        }
    },

    showMiniCart: (closeOnTime = true) => {
        miniCart.attachMock();
        setTimeout(() => {
            miniCart.cart.fadeIn();
            if (!miniCart.body.hasClass('page--greyout')) {
                miniCart.body.on('click.minicart-backdrop', function (evt) {
                    // Workaround for preselectFirstAvailableSize function. Code triggers click events and closes the backdrop
                    if ($(evt.target).hasClass('js-ctl__select-size')) {
                        return;
                    }

                    if (!$(evt.target).closest('.miniCart__wrapper').length && miniCart.active) {
                        miniCart.hideMiniCart();
                    }
                });
            }
            page.addBackdrop(true, miniCart.body);
        }, 500);
        miniCart.load();
        if (closeOnTime) {
            miniCart.closeOnTime();
        }
        miniCart.active = true;
    },

    hideMiniCart: () => {
        miniCart.body.off('mouseleave', '.miniCart__wrapper', miniCart.closeOnTime);
        miniCart.cart.fadeOut();
        page.addBackdrop(false, miniCart.body);
        miniCart.body.off('click.minicart-backdrop');
        miniCart.active = false;
        clearTimeout(miniCart.timeout);
    },

    closeOnTime: () => {
        if (miniCart.timeout) {
            clearTimeout(miniCart.timeout);
        }
        miniCart.timeout = setTimeout(miniCart.hideMiniCart, 5000);
    },

    cancelTimeout: () => {
        if (miniCart.timeout) {
            clearTimeout(miniCart.timeout);
            miniCart.timeout = undefined;
        }
    },

    checkIfCartEmpty() {
        if (miniCart.cart.data('empty')) {
            setTimeout(function () {
                miniCart.hideMiniCart();
            }, 1500);
        }
    },

    removeItem(evt) {
        evt.preventDefault();
        const entryNumber = evt.currentTarget.dataset.entryNumber;

        $(evt.target).parents('.miniCart__item').addClass('miniCart__to-remove');
        const request = removeCartItem.removeItemFromCart(entryNumber, false);
        request.done(() => {
            miniCart.load(true);
        });
    },

    changeAmount(cartAction, evt) {
        const dataset = evt.currentTarget.dataset;
        const $item = $(evt.target).closest('.miniCart__item');

        $item.addClass('miniCart__to-remove');
        selectQuantity.updateQuantityRequest(dataset.entryNumber, dataset.newQuantity)
                      .done((response) => {
                          if (response.success === true) {
                              if (response.trackingProductData) {
                                  cartTracking.trackCartAction(cartAction, response.trackingProductData, dataset.oldQuantity,
                                          dataset.newQuantity);
                                  consumerEvents.trackUpdateCartEvent(response.trackingProductData, dataset.oldQuantity,
                                          dataset.newQuantity);
                              }
                              miniCart.load(true);
                          } else {
                              $item.find('.js-minicart__item-errors').html(response.message);
                              $item.removeClass('miniCart__to-remove');
                          }
                      })
                      .fail((jqXHR) => {
                          logger.error(`${jqXHR.status} error in miniCart.increaseItem`);
                      })
                      .always(() => {
                          spinner.visibility(false);
                      })
    },

    proceedToCheckout() {
        dataLayer.push(window.alphatauri.miniCartTracking.begin_checkout);
        window.location.href = `${urlService.getBaseUrl()}cart/checkout`;
    }
}

$(() => {
    miniCart.cacheSelectors();
    miniCart.attachEvents();
    if (miniCart.showMiniCartAfterLoad) {
        // Workaround for preselectFirstAvailableSize function. Code triggers click events and closes the backdrop
        setTimeout(() => {
            miniCart.showMiniCart(false);
        }, 300)
    }
});

if (location.hash !== null && location.hash.includes('showMiniCart')) {
    miniCart.showMiniCartAfterLoad = true;
}

export default miniCart;